module.exports = __webpack_public_path__ + "0f3d09a0ebee08cd7b071884929b0fe7.svg";